// extracted by mini-css-extract-plugin
export var chevronIcon = "_87-2";
export var teamName = "_87-1";
export var teamSwitcherButton = "_87-0";